import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  title: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#111827',
  },
  codeCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    transition: 'borderColor 0.2s',
    backgroundColor: 'white',
    marginBottom: '30px',
    cursor: 'default',
    padding: '0 5px',
    background: '#f4f5f6',
  },
  codeLabel: {
    fontSize: '0.75rem',
    color: '#DB5C0E',
    letterSpacing: '0.05em',
    fontWeight: 600,
  },
  codeValue: {
    fontSize: '1.125rem',
    color: '#111827',
    fontWeight: 700,
  },
  cardTime: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
  },
  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  codeIcon: {
    backgroundColor: '#f3e8ff',
    color: '#7c3aed',
  },
  nameIcon: {
    backgroundColor: '#ecfdf5',
    color: '#10b981',
  },
  scheduledIcon: {
    backgroundColor: '#eff6ff',
    color: '#2563eb',
  },
  expiryIcon: {
    backgroundColor: '#fff7ed',
    color: '#DB5C0E',
  },

  timeLabel: {
    fontSize: 10,
    textTransform: 'uppercase',
    color: '#DB5C0E',
    fontWeight: 700,
    letterSpacing: '0.08em',
  },
  timeValue: {
    fontWeight: 500,
    color: '#374151',
  },
  modalWrapper: {
    borderRadius: '8px',
    padding: '20px',
    maxWidth: '450px',
    width: '100%',
    boxSizing: 'border-box',
  },
  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '30px',
    textAlign: 'center',
  },
  fieldWrapper: {
    marginBottom: '20px',
  },
  buttonWrapper: {
    gap: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    outline: 'none',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderWidth: '2px',
        borderColor: 'transparent',
      },
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
    '& .MuiOutlinedInput-input': {
      marginLeft: 0,
    },
  },
  iconContainer: {
    marginBottom: '16px',
  },
  icon: {
    margin: '0 auto',
    display: 'block',
  },
});
